var _g, _path, _ellipse, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardThreeIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 64,
    viewBox: "0 0 58 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2230_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 5.28595 0 2.92893 1.46447 1.46447C2.92893 0 5.28595 0 10 0H29C37.381 0 41.5715 0 44.9223 1.23617C50.4116 3.26125 54.7387 7.58844 56.7638 13.0777C58 16.4285 58 20.619 58 29C58 37.381 58 41.5715 56.7638 44.9223C54.7387 50.4116 50.4116 54.7387 44.9223 56.7638C41.5715 58 37.381 58 29 58H10C5.28595 58 2.92893 58 1.46447 56.5355C0 55.0711 0 52.714 0 48V10Z",
    fill: "#FB993D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8541 45.396C14.7821 45.396 12.4301 44.256 10.7981 41.976C9.19006 39.672 8.38606 36.42 8.38606 32.22C8.38606 29.412 8.74606 27.048 9.46606 25.128C10.2101 23.184 11.2781 21.72 12.6701 20.736C14.0861 19.728 15.8141 19.224 17.8541 19.224C20.9501 19.224 23.3021 20.34 24.9101 22.572C26.5181 24.78 27.3221 27.996 27.3221 32.22C27.3221 35.028 26.9501 37.416 26.2061 39.384C25.4861 41.328 24.4301 42.816 23.0381 43.848C21.6461 44.88 19.9181 45.396 17.8541 45.396ZM17.8541 40.86C19.2461 40.86 20.2781 40.176 20.9501 38.808C21.6221 37.416 21.9581 35.22 21.9581 32.22C21.9581 29.22 21.6221 27.06 20.9501 25.74C20.2781 24.42 19.2461 23.76 17.8541 23.76C16.4621 23.76 15.4301 24.42 14.7581 25.74C14.0861 27.06 13.7501 29.22 13.7501 32.22C13.7501 35.22 14.0861 37.416 14.7581 38.808C15.4301 40.176 16.4621 40.86 17.8541 40.86ZM39.548 45.396C38.276 45.396 36.98 45.252 35.66 44.964C34.364 44.652 33.236 44.22 32.276 43.668C31.652 43.332 31.22 42.936 30.98 42.48C30.764 42 30.68 41.532 30.728 41.076C30.8 40.62 30.992 40.224 31.304 39.888C31.616 39.528 32.012 39.3 32.492 39.204C32.996 39.108 33.548 39.204 34.148 39.492C35.084 39.948 35.972 40.272 36.812 40.464C37.652 40.656 38.492 40.752 39.332 40.752C40.292 40.752 41.096 40.632 41.744 40.392C42.392 40.128 42.884 39.756 43.22 39.276C43.556 38.796 43.724 38.196 43.724 37.476C43.724 36.468 43.376 35.712 42.68 35.208C41.984 34.704 40.964 34.452 39.62 34.452H37.496C36.704 34.452 36.092 34.26 35.66 33.876C35.252 33.468 35.048 32.916 35.048 32.22C35.048 31.5 35.252 30.948 35.66 30.564C36.092 30.156 36.704 29.952 37.496 29.952H39.08C39.896 29.952 40.58 29.832 41.132 29.592C41.708 29.328 42.152 28.968 42.464 28.512C42.8 28.056 42.968 27.492 42.968 26.82C42.968 25.86 42.632 25.128 41.96 24.624C41.312 24.12 40.364 23.868 39.116 23.868C38.348 23.868 37.592 23.964 36.848 24.156C36.104 24.324 35.3 24.636 34.436 25.092C33.908 25.356 33.416 25.44 32.96 25.344C32.504 25.248 32.12 25.032 31.808 24.696C31.52 24.36 31.328 23.976 31.232 23.544C31.16 23.088 31.22 22.632 31.412 22.176C31.628 21.72 32.012 21.348 32.564 21.06C33.596 20.46 34.712 20.004 35.912 19.692C37.136 19.38 38.372 19.224 39.62 19.224C41.444 19.224 43.004 19.5 44.3 20.052C45.596 20.604 46.592 21.396 47.288 22.428C47.984 23.436 48.332 24.66 48.332 26.1C48.332 27.084 48.14 27.984 47.756 28.8C47.372 29.616 46.832 30.312 46.136 30.888C45.464 31.44 44.636 31.836 43.652 32.076V31.608C45.356 31.896 46.688 32.604 47.648 33.732C48.608 34.86 49.088 36.276 49.088 37.98C49.088 39.492 48.704 40.812 47.936 41.94C47.168 43.044 46.064 43.896 44.624 44.496C43.208 45.096 41.516 45.396 39.548 45.396Z",
    fill: "#FFFEFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.0227,
    cy: 10.5,
    rx: 7.60186,
    ry: 2.95423,
    transform: "rotate(31.6062 46.0227 10.5)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59497,
    cy: 51.5551,
    rx: 4.07411,
    ry: 2.17568,
    transform: "rotate(22.2251 6.59497 51.5551)",
    fill: "white",
    fillOpacity: 0.91
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2230_175",
    x: 0,
    y: 0,
    width: 58,
    height: 63.5172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.51724
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.773077 0 0 0 0 0.382745 0 0 0 0 0.0163107 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2230_175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2230_175",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardThreeIndicator);
export default __webpack_public_path__ + "static/media/card-three-indicator.7fe54c082de6f00739372cee3d79ea2d.svg";
export { ForwardRef as ReactComponent };